import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';

// Schéma de validation pour le formulaire
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Le nom est requis'),
  //libelle: Yup.string(),
  //observation: Yup.string(),
  reference: Yup.string(),
  implantation: Yup.string(),
  historique: Yup.string(),
  brigadeId: Yup.string().required('La brigade est requise'),
});

const EditBataillon = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [listUser, setListUsers] = useState([]);
  const [bataillon, setBataillon] = useState({
    name: '',
    libelle: '',
    observation: '',
    reference: '',
    implantation: '',
    historique: '',
    brigadeId: '',
    userId: '',
  });

  const [brigades, setBrigades] = useState([]); // État pour stocker la liste des brigades
  const [errors, setErrors] = useState({}); // État pour stocker les erreurs de validation

  // Fonction pour récupérer les données du bataillon à modifier
  useEffect(() => {
    const fetchBataillon = async () => {
      try {
        const response = await axios.get(`bataillon/xx/${id}`);
        setBataillon(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération du bataillon :', error);
      }
    };

    const fetchBrigades = async () => {
      try {
        const response = await axios.get('/brigade');
        setBrigades(response.data); // Remplit l'état avec les brigades disponibles
      } catch (error) {
        console.error('Erreur lors de la récupération des brigades :', error);
      }
    };

    fetchBataillon();
    fetchBrigades();
  }, [id]);



  useEffect(() => {
    try {
      axios.get('/auth').then((response) => {
        setListUsers(response.data);
        console.log(response.data);
      });

    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs :', error);
    }

  }, []);


  const handleChange = (e) => {
    setBataillon({ ...bataillon, [e.target.name]: e.target.value });
  };

  // Fonction de gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Valider les données avant d'envoyer la requête
    try {
      await validationSchema.validate(bataillon, { abortEarly: false });
      setErrors({});

      // Envoyer les données mises à jour au backend
      await axios.put(`bataillon/${id}`, bataillon);

      toast.info('Enregistrement terminé avec succés')
      navigate('/bataillon'); // Rediriger vers la liste des bataillons après la modification
    } catch (validationErrors) {
      if (validationErrors.inner) {
        // Créer un objet erreurs basé sur les messages de validation
        const validationErrorsObj = validationErrors.inner.reduce((acc, err) => {
          acc[err.path] = err.message;
          return acc;
        }, {});
        setErrors(validationErrorsObj);
      }
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <h2>Modifier Bataillon</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nom :</label>
          <input className="form-control" type="text" name="name" value={bataillon.name} onChange={handleChange} />
          {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
        </div>
        <div>
          <label>Libellé :</label>
          <input className="form-control" type="text" name="libelle" value={bataillon.libelle} onChange={handleChange} />
          {errors.libelle && <p style={{ color: 'red' }}>{errors.libelle}</p>}
        </div>
        <div>
          <label>Observation :</label>
          <input className="form-control" type="text" name="observation" value={bataillon.observation} onChange={handleChange} />
          {errors.observation && <p style={{ color: 'red' }}>{errors.observation}</p>}
        </div>
        <div>
          <label>Référence :</label>
          <input className="form-control" type="text" name="reference" value={bataillon.reference} onChange={handleChange} />
          {errors.reference && <p style={{ color: 'red' }}>{errors.reference}</p>}
        </div>
        <div>
          <label>Implantation :</label>
          <input className="form-control" type="text" name="implantation" value={bataillon.implantation} onChange={handleChange} />
          {errors.implantation && <p style={{ color: 'red' }}>{errors.implantation}</p>}
        </div>
        <div>
          <label>Historique :</label>
          <input className="form-control" type="text" name="historique" value={bataillon.historique} onChange={handleChange} />
          {errors.historique && <p style={{ color: 'red' }}>{errors.historique}</p>}
        </div>
        <div>
          <label>Brigade :</label>
          <select className="form-control" name="brigadeId" value={bataillon.brigadeId} onChange={handleChange}>
            <option value="">Sélectionner une brigade</option>
            {brigades.map((brigade) => (
              <option key={brigade.id} value={brigade.id}>
                {brigade.name}
              </option>
            ))}
          </select>
          {errors.brigadeId && <p style={{ color: 'red' }}>{errors.brigadeId}</p>}
        </div>
        <div>
          <label>Utilisateur responsable :</label>
          <select className="form-control" name="userId" value={bataillon.userId || ''} onChange={handleChange}>
            <option value="">Sélectionner un utilisateur</option>
            {listUser.map((user) => (
              <option key={user.id} value={user.id}>{user.username}</option>
            ))}
          </select>
        </div>
        <button className="btn btn-primary m-4" type="submit">
          Enregistrer les modifications
        </button>
      </form>
    </div>
  );
};

export default EditBataillon;
